import React from 'react';
import { CheckboxGroup } from '@into-discovery/browsewebshared';
import ClearSearchFilters from '@/components/atoms/search/clear-search-filter/clear-search-filters';
import { useQueryFacets } from '@into-discovery/browsewebshared';
import { ICheckboxGroup } from '@into-discovery/browsewebshared';
import { IOption } from '@into-discovery/browsewebshared';
import ToggleButton from '@/components/atoms/search/toggle-button/toggle-button';
import styles from './search-filters-desktop.module.scss';
import { useFacets } from '@/hooks/use-facet.hook';
import { useSearchParams } from 'next/navigation';

type Props = {
  filters: ICheckboxGroup[];
  showAll: boolean;
  toggleShowAll: (isActive: boolean) => void;
};

export default function SearchFiltersDesktop({
  filters = [],
  showAll = false,
  toggleShowAll,
}: Props) {
  const searchParams = useSearchParams();
  const queryFacets = useQueryFacets(searchParams);
  const isToggleButtonVisible =
    filters.find((f) => f.name === process.env.NEXT_PUBLIC_UNIVERSITY_FACET_NAME)?.options?.length >
    10;

  const [filtersToDisplay] = useFacets(filters, showAll);

  const toggleButtonClick = (isActive: boolean) => {
    toggleShowAll(isActive);
  };

  const onChangeCheckbox = (option: IOption, filter: ICheckboxGroup) => {
    if (option.selected) {
      queryFacets.addFacetTerm(filter.id, `"${option.id}"`);
    } else {
      queryFacets.removeFacetTerm(filter.id, option.id);
    }
  };

  return filters?.length === 0 ? null : (
    <>
      <div className="d-lg-flex justify-content-between ">
        <h4 className="mb-0 font-family-lato">Filter by</h4>
        <ClearSearchFilters displayText="Clear all" />
      </div>
      <hr />
      <div className={`${styles[`facets-container`]}`}>
        {filtersToDisplay.map((filter) => (
          <CheckboxGroup key={filter.name} filter={filter} onChangeCheckbox={onChangeCheckbox} />
        ))}
      </div>
      {isToggleButtonVisible && (
        <ToggleButton
          isActive={showAll}
          onClick={toggleButtonClick}
          inactiveAriaLabel="Show more universities"
          activeAriaLabel="Show less universities"
        />
      )}
    </>
  );
}
